export enum FieldsEnum {
  companyName = 'companyName',
  role = 'role',
}

export enum RolesEnum {
  entrepreneur = 'entrepreneur',
  salesManager = 'salesManager',
  marketingManager = 'marketingManager',
  customerSuccessManager = 'customerSuccessManager',
  operationsManager = 'operationsManager',
  ITAdministrator = 'ITAdministrator',
  cLevel = 'C-level',
  vp = 'VP',
  director = 'Director',
  manager = 'Manager',
  individualContributor = 'Individual contributor',
  other = 'other',
}

export enum CompanySizeEnum {
  justMe = 'Just me',
  size_2_10 = '2-10',
  size_11_19 = '11-19',
  size_20_49 = '20-49',
  size_50_99 = '50-99',
  size_100_249 = '100-249',
  size_250_500 = '250-500',
  size_500_more = '500+',
}

export type IRole = {
  id: RolesEnum
  name: string
}

export type ICompanySize = {
  id: CompanySizeEnum
  name: string
}

export type IParamsRegisterGtmAnswersStep1 = {
  role: string
  company_size: string
}
